import "clsx";
function Markdown($$payload, $$props) {
  let { children } = $$props;
  $$payload.out.push(`<div class="markdown svelte-1iiu9kv">`);
  children($$payload);
  $$payload.out.push(`<!----></div>`);
}
function _layout($$payload, $$props) {
  let { children } = $$props;
  Markdown($$payload, {
    children: ($$payload2) => {
      children($$payload2);
      $$payload2.out.push(`<!---->`);
    }
  });
}
export {
  _layout as default
};
